import React from 'react'
import {
  DsAccordion,
  DsRemixIcon,
  DsStack,
  DsTypography
} from '@am92/react-design-system'

import { T_FAQ_CATEGORY } from '~/src/Types/Faq.Types'

interface IFaqCategoryProps {
  faqCategory: T_FAQ_CATEGORY
}

const FaqCategory: React.FC<IFaqCategoryProps> = props => {
  const { faqCategory } = props

  return (
    <DsStack direction='column' spacing='var(--ds-spacing-frostbite)'>
      <DsTypography variant='headingBoldExtraLarge' textAlign='center'>
        {faqCategory.categoryName}
      </DsTypography>

      {faqCategory.faqs.map((faq, faqIndex) => {
        return (
          <DsAccordion
            key={faqIndex}
            header={
              <DsStack
                direction='row'
                alignItems='center'
                spacing='var(--ds-spacing-glacial)'
              >
                <DsRemixIcon className='ri-lightbulb-line' fontSize='cool' />
                <DsTypography variant='bodyRegularLarge'>
                  {faq.question}
                </DsTypography>
              </DsStack>
            }
            summary={<DsTypography>{faq.answer}</DsTypography>}
            sx={{
              border: '1px solid var(--ds-colour-strokeDefault)'
            }}
          />
        )
      })}
    </DsStack>
  )
}

export default FaqCategory
